
import {isCurrentRoute} from './navbar-defs.js'
import NavbarItem from './navbar-item.vue'
import ChatsItem from './chats-item.vue'

export default {
  components: {
    NavbarItem,
    ChatsItem
  },
  props: {
    type: {type: String, default: undefined},
    items: {type: Array, default: () => []},
    level: {type: Number, default: 0},
  },
  emits: ['show'],
  data() {
    return {
      opened: this.items.map(x => x.opened || false)
    }
  },
  watch: {
    '$route.fullPath'(){
      if(this.level > 0) return
      this.openByRoute()
    }

  },
  mounted(){
    this.openByRoute()
  },
  methods: {
    isCurrentRoute(item){
      return isCurrentRoute(this.$route, item)
    },
    toLink(path, query){
      // Defer navigation until pending component actions have finished.
      setTimeout(() => {
        this.$router.push(query ? {path, query} : path)
        if (this.$responsive.mobile) this.$dispatch('toggle-burger')
      })
    },
    openByRoute(){
      const item_ind = this.items.findIndex(this.isCurrentRoute)
      if (item_ind !== -1) {
        this.opened[item_ind] = true
      }
    },
    onLinkClick(ind, item){
      if (this.isCurrentRoute(item) && item.children?.length)
        this.onNotLinkClick(ind)
      else
        this.toLink(item.route, item.query)

    },
    onNotLinkClick(ind){
      this.opened[ind] = !this.opened[ind]
    }
  }
}
